<template>
  <Modal :value="open" :onClose="close" :close="false" title="Pagamento">
    <b-row class="form-group">
      <b-col class="busca">
        <SelectWithRegister
          label="Forma de Pagamento"
          placeholder="Informe a forma de pagamento"
          labelBusca="name"
          :value="pagamento"
          :handleRegister="false"
          ref="buscaPagamentos"
          :options="pagamentosFilteredText"
          inputClass="busca-cliente"
          :search="searchPagamentos"
          :change="changePagamentos"
        >
          <template slot="options" slot-scope="props">
            <div class="selected" :key="props.data.name" style="text-transform: uppercase;">
              {{ props.data.name + ' - ' + props.data.paymentType.name }}
            </div>
          </template>
          <template slot="selected" slot-scope="props">
            <div class="selected" :key="props.data.name" style="text-transform: uppercase;">
              {{ props.data.name ? props.data.name + ' - ' + props.data.paymentType.name : '' }}
            </div>
          </template>
        </SelectWithRegister>
      </b-col>
    </b-row>
    <b-row class="form-group" v-if="meioPagamentoIsOutros">
      <b-col>
        <Label bold>Descrição Forma de Pagamento</Label>
        <Input
          id="descricaoMeioPagamento"
          ref="descricaoMeioPagamento"
          class="busca-cliente"
          v-model="descricaoMeioPagamento"
          maxlength="36"
        />
      </b-col>
    </b-row>
    <div v-if="showPaymentTransaction">
      <b-row class="form-group" v-if="pagamentoNoCartao">
        <b-col class="busca">
          <Label bold>Parcelas</Label>
          <Input
            id="parcela"
            ref="parcela"
            class="busca-cliente"
            v-model="parcela"
            type="number"
            :disabled="true"
          />
        </b-col>
        <b-col class="busca">
          <Label bold>Operação</Label>
          <Input
            id="operacao"
            ref="operacao"
            class="busca-cliente"
            v-model="operacao"
            :disabled="true"
          />
        </b-col>
      </b-row>
      <b-row class="form-group">
        <b-col class="busca" v-if="pagamentoNoCartao">
          <SelectWithRegister
            label="Bandeiras"
            placeholder="Informe a bandeira"
            labelBusca="name"
            :value="bandeira"
            ref="searchBandeiras"
            :options="bandeirasFilteredText"
            inputClass="busca-cliente"
            :register="registerBandeira"
            :search="searchBandeiras"
            registerLabel="Cadastrar Bandeira"
            :change="changeBandeira"
          >
            <template slot="options" slot-scope="props">
              <div class="selected" style="text-transform: uppercase;">
                {{ props.data.name }}
              </div>
            </template>
          </SelectWithRegister>
        </b-col>
        <b-col class="busca">
          <SelectWithRegister
            label="Administradora"
            placeholder="Informe a administradora"
            labelBusca="name"
            :value="administradora"
            ref="searchAdministradora"
            :options="administradorasFilteredText"
            inputClass="busca-cliente"
            :register="registerCardManager"
            :search="searchAdministradoras"
            registerLabel="Cadastrar Administradora"
            :change="changeAdministradoras"
            handleChange="registerAdministradora"
          >
            <template slot="options" slot-scope="props">
              <div class="selected" :key="props.data.name" style="text-transform: uppercase;">
                {{ props.data.name }}
              </div>
            </template>
          </SelectWithRegister>
        </b-col>
      </b-row>
    </div>
    <b-row class="form-group">
      <b-col class="busca" v-if="showTransactionNumber()">
        <Label bold>Número da Transação</Label>
        <Input
          id="numeroTransacao"
          ref="numeroTransacao"
          class="busca-cliente"
          v-model="numeroTransacao"
          :type="'number'"
        />
      </b-col>
      <b-col class="busca" v-if="showIdTermPag()">
        <Label bold>Identificador terminal de pagamento</Label>
        <Input id="idTermPag" ref="idTermPag" v-model="idTermPag" :type="'text'" :maxlength="40" />
      </b-col>
    </b-row>
    <b-row class="form-group">
      <b-col md="6">
        <Label bold>Valor</Label>
        <Money
          ref="valorPagamento"
          id="valorPagamento"
          labelBold
          inputClass="form-control input"
          :onEnter="adicionarPagamento"
          v-model="valorPgto"
          :description="errorValue('value')"
          :error="!!errorValue('value')"
        />
        <a href="javascript:" @click="adicionarPagamento" class="add-pgto">
          <Add title="Adicionar" />
        </a>
        <small>Enter p/ adicionar valor</small>
      </b-col>
    </b-row>
    <b-row class="form-group" v-if="listaPagamentos.length > 0">
      <b-col class="busca">
        <table class="table">
          <thead>
            <tr>
              <th>Forma de Pagamento</th>
              <th>Valor</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(p, key) in listaPagamentos" :key="'pagamento' + key">
              <td>
                {{ p.name }} <span v-if="p.paymentType"> - {{ p.paymentType.name }}</span>
              </td>
              <td>R$ {{ valorReal(p.value) }}</td>
              <td align="right">
                <a href="javascript:" @click="removePagamento" class="remove-pgto">
                  <Close title="Excluir" />
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>

    <ModalRegisterCardManager
      :close="modalCardManagerToogle"
      :open="modalCardManager"
      :onSave="saveCardManager"
    />

    <div class="confirm-buttons">
      <Button type="error" @click="close()">Fechar</Button>
      <Button type="success" @click="save()">Gravar</Button>
    </div>
  </Modal>
</template>

<script>
import { Modal } from '@/components';
import { Button, Label, SelectWithRegister, Input } from '@/components/Form';
import Close from 'vue-material-design-icons/Close';
import Add from 'vue-material-design-icons/Plus';
import { mapActions } from 'vuex';
import FormatMixin from '@/modules/Application/mixins/FormatMixin';
import InstallmentsMixin from '@/modules/Application/mixins/InstallmentsMixin';
import { ClientMixin } from '@/modules/Application';
import Money from '../Form/InputMoney';
import PagamentosMixin from '../../mixins/PagamentosMixin';
import BandeirasMixin from '../../mixins/BandeirasMixin';
import AdministradorasMixin from '../../mixins/AdministradorasMixin';
import ModalRegisterCardManager from '../ModalRegisterCardManager';
import { MEIOS_PAGAMENTO } from '../../../../enums/MeioPagamento';
import {
  ID_ADMINISTRATION_STONE,
  TPAG_CARTAO_CREDIT,
  TPAG_CARTAO_DEBIT,
  TPAG_PIX,
} from '../../../../enums/PaymentMode';
import { ELETRONIC_TPAGS } from '../../enums/Payment';

const MONEY_PAYMENT = 'À vista';

export default {
  name: 'ModalPagamentos',
  mixins: [
    FormatMixin,
    PagamentosMixin,
    BandeirasMixin,
    AdministradorasMixin,
    InstallmentsMixin,
    ClientMixin,
  ],
  components: {
    Close,
    Modal,
    Button,
    Label,
    Money,
    SelectWithRegister,
    Input,
    ModalRegisterCardManager,
    Add,
  },
  data() {
    return {
      valorPagoVenda: 0,
      valorTotal: '0',
      modalCardManager: false,
      pagamento: null,
      listaPagamentos: [],
      listaFormaPagamentos: [],
      bandeiras: null,
      bandeirasFilteredText: [],
      administradorasFilteredText: [],
      administradora: null,
      administradoras: [],
      numeroTransacao: null,
      idTermPag: null,
      showPaymentTransaction: false,
      isEletronicTPags: false,
      pagamentoNoCartao: false,
      bandeira: null,
      parcela: null,
      operacao: '',
      valorPgto: 0,
      quantity: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        precision: 2,
        masked: true,
      },
      errors: {},
      meioPagamentoIsOutros: false,
      descricaoMeioPagamento: null,
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    close: {
      type: Function,
      required: true,
    },
    changePagamentoVenda: {
      type: Function,
      required: true,
    },
    total: {
      required: true,
    },
    pagamentosVenda: {
      required: true,
    },
    valorPago: {
      required: true,
    },
  },
  watch: {
    async bandeira() {
      await localStorage.setItem('lastFlag', JSON.stringify(this.bandeira));
    },
    async administradora() {
      if (JSON.stringify(this.administradora) !== null) {
        await localStorage.setItem('lastCardManager', JSON.stringify(this.administradora));
      }
    },
    pagamentosVenda(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.listaPagamentos = newValue;
      }
    },
    total(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.valorTotal = newValue;
        this.checkValorPago();
      }
    },
    valorPago(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.valorPagoVenda = newValue;
        this.checkValorPago();
      }
    },
  },
  mounted() {
    const getDataInit = async () => {
      this.setLoading(true);
      await this.getClient();
      await this.getPagamentos();
      await this.handleGetBandeiras();
      await this.handleGetAdministradoras();
      this.setLoading(false);
    };
    getDataInit();
    this.errors = {};
  },
  methods: {
    ...mapActions('application', ['setLoading']),
    checkValorPago(valor = 0) {
      if (this.valorPagoVenda === 0 && valor === 0) {
        this.valorPgto = this.valorSubTotalReal(this.total);
        return;
      }

      const valorPagar = this.total - (this.valorPagoVenda + valor);
      this.valorPgto = valorPagar < 0 ? '0,00' : this.valorSubTotalReal(valorPagar);
      this.valorPagoVenda += valor;
    },
    modalCardManagerToogle() {
      this.modalCardManager = !this.modalCardManager;
    },
    async saveCardManager(value) {
      try {
        if (value.name && value.identification) {
          await this.$http.post('inventory.post-card-administrator', { ...value, active: true });
          this.$alert.success('Administradora cadastrada com sucesso!');
          this.modalCardManagerToogle();
          await this.handleGetAdministradoras();
        }
      } catch (e) {
        this.$alert.error(e);
      }
    },
    async handleGetBandeiras() {
      await this.getBandeiras();
      this.bandeirasFilteredText = this.bandeiras;
    },
    async handleGetAdministradoras() {
      await this.getAdministradoras();
      this.administradorasFilteredText = this.administradoras;
    },
    errorValue(field) {
      return this.errors[field];
    },
    async validarCampos(pagamento) {
      const { schema, validate } = this.$validate;
      const schemaConfiguration = schema.object().shape({
        value: schema
          .number()
          .required()
          .min(0.01),
        paymentType: schema.mixed().required(),
      });

      this.errors = {};
      const validations = await validate(schemaConfiguration, pagamento);
      if (!validations.status) {
        this.errors = validations.data;
      }
    },
    async sumTotalPaymentCollectionWithPaymentValue() {
      const sumPaymentModeCollection = this.listaPagamentos.reduce(
        (acc, cur) => cur.value + acc,
        0,
      );

      const total = sumPaymentModeCollection + (await this.valorUS(this.valorPgto));
      return total;
    },
    sumTotalPaymentInMoney() {
      const total = 0;
      const paymentMoneyCollection = this.filterPaymentMoneyInCollection();

      if (!paymentMoneyCollection) {
        return total;
      }

      const totalValueMoneyPayment = paymentMoneyCollection.reduce(
        (acc, cur) => acc + cur.value,
        0,
      );

      return totalValueMoneyPayment;
    },
    filterPaymentMoneyInCollection() {
      return this.listaPagamentos.filter(
        (element) => element.paymentType.tPag === MEIOS_PAGAMENTO.dinheiro,
      );
    },
    filterMeansOfPaymentMoneyInCollection() {
      return this.listaPagamentos.filter(
        (element) => element.paymentType.tPag === MEIOS_PAGAMENTO.dinheiro,
      );
    },
    async adicionarPagamento() {
      if (!this.pagamento.name) {
        return false;
      }

      const valor = await this.valorUS(this.valorPgto);
      const remainder = (await this.sumTotalPaymentCollectionWithPaymentValue()) - this.total;
      const totalMoneyPayed = this.sumTotalPaymentInMoney();

      if (
        remainder > 0 &&
        this.pagamento.name !== MONEY_PAYMENT &&
        this.valorUS(this.valorPgto) > totalMoneyPayed &&
        remainder >= totalMoneyPayed
      ) {
        this.$alert.warning(
          'Valor do troco deve ser menor que o total em dinheiro e não pode ser gerado quando não houver esta forma de pagamento.',
        );
        this.errors.invalidRemainder = true;
        return false;
      }

      let haveMoreThatOneInMoney = false;
      if (this.pagamento && this.filterPaymentMoneyInCollection().length) {
        const { paymentType } = this.pagamento;

        haveMoreThatOneInMoney = paymentType.tPag === MEIOS_PAGAMENTO.dinheiro;
      }

      if (haveMoreThatOneInMoney) {
        this.$alert.warning('Não é possível adicionar mais que um meio de pagamento em dinheiro.');
        return false;
      }

      this.errors = {};

      let pagamento = {
        value: valor,
        ...this.pagamento,
      };

      await this.validarCampos(pagamento);

      if (valor > 0 && pagamento.name) {
        if (this.showPaymentTransaction || this.isEletronicTPags) {
          pagamento = {
            ...pagamento,
            flag: this.pagamentoNoCartao ? this.bandeira : null,
            cardAdministrator: this.administradora ?? null,
            transactionNumber: this.numeroTransacao,
            idTermPag: this.idTermPag,
          };
        }

        if (this.meioPagamentoIsOutros && !this.descricaoMeioPagamento) {
          return false;
        }

        if (this.meioPagamentoIsOutros) {
          pagamento = {
            ...pagamento,
            meioPagamentoDescription: this.descricaoMeioPagamento,
          };
        }

        const range = this.calculateInstallments(
          pagamento,
          parseFloat(pagamento.value),
          pagamento.id,
        );

        pagamento = {
          ...pagamento,
          range,
        };

        const pagymentModeStone = this.listaPagamentos.filter(
          (e) =>
            e.cardAdministrator &&
            e.cardAdministrator.id === ID_ADMINISTRATION_STONE &&
            [TPAG_CARTAO_DEBIT, TPAG_CARTAO_CREDIT].indexOf(e.paymentType.tPag) !== -1,
        );

        if (
          pagymentModeStone.length > 0 &&
          [TPAG_CARTAO_DEBIT, TPAG_CARTAO_CREDIT].indexOf(pagamento.paymentType.tPag) !== -1
        ) {
          this.$alert.success(
            'A integração com a Stone não está disponível para mais de um pagamento no cartão, efetue a cobrança manualmente na maquininha de cartão!',
          );
        }

        this.listaPagamentos.push(pagamento);

        await this.checkValorPago(pagamento.value);

        this.parcela = null;
        this.operacao = null;
        this.bandeira = null;
        this.numeroTransacao = null;
        this.administradora = null;
        this.idTermPag = null;
        this.pagamento = null;

        await this.changePagamentos({});

        if (this.valorUS(this.valorPgto) > 0) {
          this.$nextTick(() => {
            this.$refs.buscaPagamentos.$el.querySelector('input').focus();
          });
        }
      }

      return true;
    },
    removePagamento(indice) {
      this.listaPagamentos.splice(indice, 1);
    },

    async modalCanBeClosed() {
      return (
        (Object.keys(this.errors).length === 3 || Object.keys(this.errors).length === 0) &&
        this.listaPagamentos.length > 0
      );
    },
    async save() {
      await this.adicionarPagamento();

      if (await this.modalCanBeClosed()) {
        this.errors = {};
        this.changePagamentoVenda(this.listaPagamentos);
      }
    },
    async registerBandeira() {
      if ('new' in this.bandeira) {
        delete this.bandeira.new;
        try {
          await this.$http.post('inventory.post-flag', { ...this.bandeira, active: true });
          this.bandeira = {};
          this.$alert.success('Bandeira cadastrada com sucesso!');
          await this.getBandeiras();
        } catch (err) {
          this.$alert.error(err);
        }
      }
    },
    changeBandeira(selectedBandeira) {
      this.bandeira = selectedBandeira;
    },
    changeAdministradoras(selectedAdministradora) {
      this.administradora = selectedAdministradora;
    },
    changePagamentos(selectedPagamento) {
      this.pagamento = selectedPagamento;
      this.verifyIfPaymentCard(this.pagamento);
      this.verifyIfIsOutros();

      this.$nextTick(() => {
        if (this.$refs.valorPagamento) {
          this.$refs.valorPagamento.$el.querySelector('input').focus();
        }
      });
    },
    showTransactionNumber() {
      if (!this.isEletronicTPags) return false;

      if (this.showPaymentTransaction) return true;

      return this.client?.fiscal?.emissor?.NT2023004;
    },
    showIdTermPag() {
      if (!this.isEletronicTPags) return false;

      return this.client?.fiscal?.emissor?.NT2023004;
    },
    async verifyIfPaymentCard(pagamento = this.pagamento) {
      if (!pagamento.paymentType) {
        return false;
      }

      const { name, tPag } = pagamento.paymentType;
      const isCard = ['Cartão de Crédito', 'Cartão de Débito'].includes(name);
      this.showPaymentTransaction = [TPAG_CARTAO_CREDIT, TPAG_CARTAO_DEBIT, TPAG_PIX].includes(
        tPag,
      );
      this.isEletronicTPags = ELETRONIC_TPAGS.includes(tPag);

      if (!pagamento || !isCard) {
        localStorage.removeItem('lastCardManager');
        this.pagamentoNoCartao = false;
        return false;
      }

      const { paymentType } = pagamento;

      this.parcela = pagamento.repeatTimes;
      this.operacao = paymentType.name;
      this.pagamentoNoCartao = true;
      await this.setBandeira(pagamento);
      await this.setAdministradora();
      return true;
    },
    setNewBandeira(name) {
      this.bandeira = { name, new: true };
    },
    searchFilter(text, array) {
      const filterList = array.filter((item) => {
        const itemFilter = item.name ? item.name.toUpperCase() : ''.toUpperCase();
        const newText = text.toUpperCase();
        return itemFilter.indexOf(newText) > -1;
      });
      return filterList;
    },
    searchBandeiras(text) {
      const filter = this.searchFilter(text, this.bandeiras);
      this.bandeirasFilteredText = filter;
      if (!filter.length) {
        this.setNewBandeira(text);
      }
    },
    searchPagamentos(text) {
      const filter = this.searchFilter(text, this.pagamentos);
      this.pagamentosFilteredText = filter;
    },
    async setBandeira(pagamento) {
      if (pagamento.flag) {
        this.bandeira = pagamento.flag;
        return;
      }

      const lastFlag = await localStorage.getItem('lastFlag');
      this.bandeira = JSON.parse(lastFlag);
    },
    async setAdministradora() {
      const lastCardManager = await localStorage.getItem('lastCardManager');
      this.administradora = JSON.parse(lastCardManager);
    },
    searchAdministradoras(text) {
      const filter = this.searchFilter(text, this.administradoras);
      this.administradorasFilteredText = filter;
    },
    registerCardManager() {
      this.modalCardManagerToogle();
    },
    verifyIfIsOutros(pagamento = this.pagamento) {
      if (!pagamento || !pagamento.paymentType) {
        this.meioPagamentoIsOutros = false;
        return false;
      }
      const { tPag } = pagamento.paymentType;
      if (tPag !== MEIOS_PAGAMENTO.outros) {
        this.meioPagamentoIsOutros = false;
        return false;
      }
      this.meioPagamentoIsOutros = true;
      return true;
    },
  },
};
</script>
